var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signal"},_vm._l((5),function(index){return _c('div',{key:index,class:_vm.getBarClass(index)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }